import type { Testimonial } from './types';

export const testimonials: Testimonial[] = [
  {
    name: '张明',
    role: '互联网从业者',
    content: '通过福利导航领到了深圳的800元消费券，还找到了好几个超值的会员联合套餐，一年省了至少2000块！现在每天都会刷一下看看有什么新福利。',
    avatarSeq: 't-zhang',
  },
  {
    name: '李婷',
    role: '全职妈妈',
    content: '作为一个精打细算的妈妈，福利导航简直是我的省钱神器。各种母婴产品的折扣信息特别全，还有教育补贴的攻略帮我省了不少培训费。',
    avatarSeq: 't-li',
  },
  {
    name: '王浩',
    role: '企业HR',
    content: '作为HR，我经常在福利导航上研究其他公司的员工福利方案。这里的职场福利板块信息非常专业，给我们的员工福利优化提供了很多参考。',
    avatarSeq: 't-wang',
  },
  {
    name: '陈雪',
    role: '自由职业者',
    content: '自由职业没有公司福利，福利导航帮我找到了很多个人可以享受的补贴和政策。社保缴纳攻略、个税优化方案这些都特别实用。',
    avatarSeq: 't-chen',
  },
];